var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _path25, _g23, _path26, _g24, _path27, _g25, _path28, _g26, _path29, _g27, _path30, _g28, _path31, _g29, _path32, _g30, _path33, _g31, _path34, _g32, _path35, _g33, _path36, _g34, _path37, _g35, _path38, _g36, _path39, _g37, _path40, _g38, _path41, _g39, _path42, _g40, _path43, _g41, _path44, _g42, _path45, _g43, _path46, _g44, _path47, _g45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessory3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 60,
    viewBox: "0 0 106 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38821 59.8428C-2.22255 45.537 2.55054 30.1361 12.0994 18.9433C33.1102 -5.99307 72.8985 -6.0119 93.912 18.9271C101.217 27.502 105.594 38.232 105.815 49.3388C105.869 52.9199 105.508 56.4634 104.607 59.8401C103.698 56.4661 102.67 53.2616 101.392 50.2267C97.8295 41.5684 91.9963 33.6446 84.9281 27.9137C52.8052 2.36658 10.6223 21.459 1.38821 59.8428Z",
    fill: "#D85DA3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38821 59.8428C-2.22255 45.537 2.55054 30.1361 12.0994 18.9433C33.1102 -5.99307 72.8985 -6.0119 93.912 18.9271C101.217 27.502 105.594 38.232 105.815 49.3388C105.869 52.9199 105.508 56.4634 104.607 59.8401C103.698 56.4661 102.67 53.2616 101.392 50.2267C97.8295 41.5684 91.9963 33.6446 84.9281 27.9137C52.8052 2.36658 10.6223 21.459 1.38821 59.8428Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_100_6374)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: -5,
    width: 13,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.928 -4.61572H99.0132V8.29908H111.928V-4.61572Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.471 10.4519C106.66 10.4519 107.623 9.48821 107.623 8.29944C107.623 7.11066 106.66 6.14697 105.471 6.14697C104.282 6.14697 103.318 7.11066 103.318 8.29944C103.318 9.48821 104.282 10.4519 105.471 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 7.2229C100.202 7.2229 101.166 6.25921 101.166 5.07044C101.166 3.88166 100.202 2.91797 99.0133 2.91797C97.8245 2.91797 96.8608 3.88166 96.8608 5.07044C96.8608 6.25921 97.8245 7.2229 99.0133 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 3.99439C106.66 3.99439 107.623 3.03069 107.623 1.84192C107.623 0.653145 106.66 -0.310547 105.471 -0.310547C104.282 -0.310547 103.318 0.653145 103.318 1.84192C103.318 3.03069 104.282 3.99439 105.471 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 0.765382C100.202 0.765382 101.166 -0.19831 101.166 -1.38708C101.166 -2.57586 100.202 -3.53955 99.0133 -3.53955C97.8245 -3.53955 96.8608 -2.57586 96.8608 -1.38708C96.8608 -0.19831 97.8245 0.765382 99.0133 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 8,
    width: 13,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.928 8.29932H99.0132V21.2141H111.928V8.29932Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.471 23.3669C106.66 23.3669 107.623 22.4033 107.623 21.2145C107.623 20.0257 106.66 19.062 105.471 19.062C104.282 19.062 103.318 20.0257 103.318 21.2145C103.318 22.4033 104.282 23.3669 105.471 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 20.1379C100.202 20.1379 101.166 19.1742 101.166 17.9855C101.166 16.7967 100.202 15.833 99.0133 15.833C97.8245 15.833 96.8608 16.7967 96.8608 17.9855C96.8608 19.1742 97.8245 20.1379 99.0133 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 16.9094C106.66 16.9094 107.623 15.9457 107.623 14.757C107.623 13.5682 106.66 12.6045 105.471 12.6045C104.282 12.6045 103.318 13.5682 103.318 14.757C103.318 15.9457 104.282 16.9094 105.471 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 13.6804C100.202 13.6804 101.166 12.7167 101.166 11.528C101.166 10.3392 100.202 9.37549 99.0133 9.37549C97.8245 9.37549 96.8608 10.3392 96.8608 11.528C96.8608 12.7167 97.8245 13.6804 99.0133 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 10.4519C106.66 10.4519 107.623 9.48821 107.623 8.29944C107.623 7.11066 106.66 6.14697 105.471 6.14697C104.282 6.14697 103.318 7.11066 103.318 8.29944C103.318 9.48821 104.282 10.4519 105.471 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 21,
    width: 13,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.928 21.2139H99.0132V34.1287H111.928V21.2139Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.471 36.2815C106.66 36.2815 107.623 35.3178 107.623 34.129C107.623 32.9403 106.66 31.9766 105.471 31.9766C104.282 31.9766 103.318 32.9403 103.318 34.129C103.318 35.3178 104.282 36.2815 105.471 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 33.0525C100.202 33.0525 101.166 32.0888 101.166 30.9C101.166 29.7113 100.202 28.7476 99.0133 28.7476C97.8245 28.7476 96.8608 29.7113 96.8608 30.9C96.8608 32.0888 97.8245 33.0525 99.0133 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 29.824C106.66 29.824 107.623 28.8603 107.623 27.6715C107.623 26.4827 106.66 25.519 105.471 25.519C104.282 25.519 103.318 26.4827 103.318 27.6715C103.318 28.8603 104.282 29.824 105.471 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 26.595C100.202 26.595 101.166 25.6313 101.166 24.4425C101.166 23.2537 100.202 22.29 99.0133 22.29C97.8245 22.29 96.8608 23.2537 96.8608 24.4425C96.8608 25.6313 97.8245 26.595 99.0133 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 23.3665C106.66 23.3665 107.623 22.4028 107.623 21.214C107.623 20.0252 106.66 19.0615 105.471 19.0615C104.282 19.0615 103.318 20.0252 103.318 21.214C103.318 22.4028 104.282 23.3665 105.471 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 34,
    width: 13,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.928 34.1289H99.0132V47.0437H111.928V34.1289Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.471 49.1965C106.66 49.1965 107.623 48.2328 107.623 47.0441C107.623 45.8553 106.66 44.8916 105.471 44.8916C104.282 44.8916 103.318 45.8553 103.318 47.0441C103.318 48.2328 104.282 49.1965 105.471 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 45.9675C100.202 45.9675 101.166 45.0038 101.166 43.8151C101.166 42.6263 100.202 41.6626 99.0133 41.6626C97.8245 41.6626 96.8608 42.6263 96.8608 43.8151C96.8608 45.0038 97.8245 45.9675 99.0133 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 42.739C106.66 42.739 107.623 41.7753 107.623 40.5865C107.623 39.3978 106.66 38.4341 105.471 38.4341C104.282 38.4341 103.318 39.3978 103.318 40.5865C103.318 41.7753 104.282 42.739 105.471 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 39.51C100.202 39.51 101.166 38.5463 101.166 37.3575C101.166 36.1688 100.202 35.2051 99.0133 35.2051C97.8245 35.2051 96.8608 36.1688 96.8608 37.3575C96.8608 38.5463 97.8245 39.51 99.0133 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 36.2815C106.66 36.2815 107.623 35.3178 107.623 34.129C107.623 32.9403 106.66 31.9766 105.471 31.9766C104.282 31.9766 103.318 32.9403 103.318 34.129C103.318 35.3178 104.282 36.2815 105.471 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 47,
    width: 13,
    height: 13
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.928 47.0435H99.0132V59.9583H111.928V47.0435Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.471 62.1111C106.66 62.1111 107.623 61.1474 107.623 59.9586C107.623 58.7698 106.66 57.8062 105.471 57.8062C104.282 57.8062 103.318 58.7698 103.318 59.9586C103.318 61.1474 104.282 62.1111 105.471 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 58.8821C100.202 58.8821 101.166 57.9184 101.166 56.7296C101.166 55.5408 100.202 54.5771 99.0133 54.5771C97.8245 54.5771 96.8608 55.5408 96.8608 56.7296C96.8608 57.9184 97.8245 58.8821 99.0133 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 55.6536C106.66 55.6536 107.623 54.6899 107.623 53.5011C107.623 52.3123 106.66 51.3486 105.471 51.3486C104.282 51.3486 103.318 52.3123 103.318 53.5011C103.318 54.6899 104.282 55.6536 105.471 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0133 52.4246C100.202 52.4246 101.166 51.4609 101.166 50.2721C101.166 49.0833 100.202 48.1196 99.0133 48.1196C97.8245 48.1196 96.8608 49.0833 96.8608 50.2721C96.8608 51.4609 97.8245 52.4246 99.0133 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 49.196C106.66 49.196 107.623 48.2324 107.623 47.0436C107.623 45.8548 106.66 44.8911 105.471 44.8911C104.282 44.8911 103.318 45.8548 103.318 47.0436C103.318 48.2324 104.282 49.196 105.471 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: -5,
    width: 14,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0134 -4.61572H86.0986V8.29908H99.0134V-4.61572Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 7.2229C100.203 7.2229 101.166 6.25921 101.166 5.07044C101.166 3.88166 100.203 2.91797 99.0138 2.91797C97.825 2.91797 96.8613 3.88166 96.8613 5.07044C96.8613 6.25921 97.825 7.2229 99.0138 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 10.4519C93.745 10.4519 94.7087 9.48821 94.7087 8.29944C94.7087 7.11066 93.745 6.14697 92.5563 6.14697C91.3675 6.14697 90.4038 7.11066 90.4038 8.29944C90.4038 9.48821 91.3675 10.4519 92.5563 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 7.2229C87.2875 7.2229 88.2512 6.25921 88.2512 5.07044C88.2512 3.88166 87.2875 2.91797 86.0988 2.91797C84.91 2.91797 83.9463 3.88166 83.9463 5.07044C83.9463 6.25921 84.91 7.2229 86.0988 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 0.765382C100.203 0.765382 101.166 -0.19831 101.166 -1.38708C101.166 -2.57586 100.203 -3.53955 99.0138 -3.53955C97.825 -3.53955 96.8613 -2.57586 96.8613 -1.38708C96.8613 -0.19831 97.825 0.765382 99.0138 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 3.99439C93.745 3.99439 94.7087 3.03069 94.7087 1.84192C94.7087 0.653145 93.745 -0.310547 92.5563 -0.310547C91.3675 -0.310547 90.4038 0.653145 90.4038 1.84192C90.4038 3.03069 91.3675 3.99439 92.5563 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 0.765382C87.2875 0.765382 88.2512 -0.19831 88.2512 -1.38708C88.2512 -2.57586 87.2875 -3.53955 86.0988 -3.53955C84.91 -3.53955 83.9463 -2.57586 83.9463 -1.38708C83.9463 -0.19831 84.91 0.765382 86.0988 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 8,
    width: 14,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0134 8.29932H86.0986V21.2141H99.0134V8.29932Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 20.1379C100.203 20.1379 101.166 19.1742 101.166 17.9855C101.166 16.7967 100.203 15.833 99.0138 15.833C97.825 15.833 96.8613 16.7967 96.8613 17.9855C96.8613 19.1742 97.825 20.1379 99.0138 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 23.3669C93.745 23.3669 94.7087 22.4033 94.7087 21.2145C94.7087 20.0257 93.745 19.062 92.5563 19.062C91.3675 19.062 90.4038 20.0257 90.4038 21.2145C90.4038 22.4033 91.3675 23.3669 92.5563 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 20.1379C87.2875 20.1379 88.2512 19.1742 88.2512 17.9855C88.2512 16.7967 87.2875 15.833 86.0988 15.833C84.91 15.833 83.9463 16.7967 83.9463 17.9855C83.9463 19.1742 84.91 20.1379 86.0988 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 13.6804C100.203 13.6804 101.166 12.7167 101.166 11.528C101.166 10.3392 100.203 9.37549 99.0138 9.37549C97.825 9.37549 96.8613 10.3392 96.8613 11.528C96.8613 12.7167 97.825 13.6804 99.0138 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 16.9094C93.745 16.9094 94.7087 15.9457 94.7087 14.757C94.7087 13.5682 93.745 12.6045 92.5563 12.6045C91.3675 12.6045 90.4038 13.5682 90.4038 14.757C90.4038 15.9457 91.3675 16.9094 92.5563 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 13.6804C87.2875 13.6804 88.2512 12.7167 88.2512 11.528C88.2512 10.3392 87.2875 9.37549 86.0988 9.37549C84.91 9.37549 83.9463 10.3392 83.9463 11.528C83.9463 12.7167 84.91 13.6804 86.0988 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 10.4519C93.745 10.4519 94.7087 9.48821 94.7087 8.29944C94.7087 7.11066 93.745 6.14697 92.5563 6.14697C91.3675 6.14697 90.4038 7.11066 90.4038 8.29944C90.4038 9.48821 91.3675 10.4519 92.5563 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 21,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0134 21.2139H86.0986V34.1287H99.0134V21.2139Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 33.0525C100.203 33.0525 101.166 32.0888 101.166 30.9C101.166 29.7113 100.203 28.7476 99.0138 28.7476C97.825 28.7476 96.8613 29.7113 96.8613 30.9C96.8613 32.0888 97.825 33.0525 99.0138 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 36.2815C93.745 36.2815 94.7087 35.3178 94.7087 34.129C94.7087 32.9403 93.745 31.9766 92.5563 31.9766C91.3675 31.9766 90.4038 32.9403 90.4038 34.129C90.4038 35.3178 91.3675 36.2815 92.5563 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 33.0525C87.2875 33.0525 88.2512 32.0888 88.2512 30.9C88.2512 29.7113 87.2875 28.7476 86.0988 28.7476C84.91 28.7476 83.9463 29.7113 83.9463 30.9C83.9463 32.0888 84.91 33.0525 86.0988 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 26.595C100.203 26.595 101.166 25.6313 101.166 24.4425C101.166 23.2537 100.203 22.29 99.0138 22.29C97.825 22.29 96.8613 23.2537 96.8613 24.4425C96.8613 25.6313 97.825 26.595 99.0138 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 29.824C93.745 29.824 94.7087 28.8603 94.7087 27.6715C94.7087 26.4827 93.745 25.519 92.5563 25.519C91.3675 25.519 90.4038 26.4827 90.4038 27.6715C90.4038 28.8603 91.3675 29.824 92.5563 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 26.595C87.2875 26.595 88.2512 25.6313 88.2512 24.4425C88.2512 23.2537 87.2875 22.29 86.0988 22.29C84.91 22.29 83.9463 23.2537 83.9463 24.4425C83.9463 25.6313 84.91 26.595 86.0988 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 23.3665C93.745 23.3665 94.7087 22.4028 94.7087 21.214C94.7087 20.0252 93.745 19.0615 92.5563 19.0615C91.3675 19.0615 90.4038 20.0252 90.4038 21.214C90.4038 22.4028 91.3675 23.3665 92.5563 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 34,
    width: 14,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0134 34.1289H86.0986V47.0437H99.0134V34.1289Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 45.9675C100.203 45.9675 101.166 45.0038 101.166 43.8151C101.166 42.6263 100.203 41.6626 99.0138 41.6626C97.825 41.6626 96.8613 42.6263 96.8613 43.8151C96.8613 45.0038 97.825 45.9675 99.0138 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 49.1965C93.745 49.1965 94.7087 48.2328 94.7087 47.0441C94.7087 45.8553 93.745 44.8916 92.5563 44.8916C91.3675 44.8916 90.4038 45.8553 90.4038 47.0441C90.4038 48.2328 91.3675 49.1965 92.5563 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 45.9675C87.2875 45.9675 88.2512 45.0038 88.2512 43.8151C88.2512 42.6263 87.2875 41.6626 86.0988 41.6626C84.91 41.6626 83.9463 42.6263 83.9463 43.8151C83.9463 45.0038 84.91 45.9675 86.0988 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 39.51C100.203 39.51 101.166 38.5463 101.166 37.3575C101.166 36.1688 100.203 35.2051 99.0138 35.2051C97.825 35.2051 96.8613 36.1688 96.8613 37.3575C96.8613 38.5463 97.825 39.51 99.0138 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 42.739C93.745 42.739 94.7087 41.7753 94.7087 40.5865C94.7087 39.3978 93.745 38.4341 92.5563 38.4341C91.3675 38.4341 90.4038 39.3978 90.4038 40.5865C90.4038 41.7753 91.3675 42.739 92.5563 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 39.51C87.2875 39.51 88.2512 38.5463 88.2512 37.3575C88.2512 36.1688 87.2875 35.2051 86.0988 35.2051C84.91 35.2051 83.9463 36.1688 83.9463 37.3575C83.9463 38.5463 84.91 39.51 86.0988 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 36.2815C93.745 36.2815 94.7087 35.3178 94.7087 34.129C94.7087 32.9403 93.745 31.9766 92.5563 31.9766C91.3675 31.9766 90.4038 32.9403 90.4038 34.129C90.4038 35.3178 91.3675 36.2815 92.5563 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 47,
    width: 14,
    height: 13
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0134 47.0435H86.0986V59.9583H99.0134V47.0435Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 58.8821C100.203 58.8821 101.166 57.9184 101.166 56.7296C101.166 55.5408 100.203 54.5771 99.0138 54.5771C97.825 54.5771 96.8613 55.5408 96.8613 56.7296C96.8613 57.9184 97.825 58.8821 99.0138 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 62.1111C93.745 62.1111 94.7087 61.1474 94.7087 59.9586C94.7087 58.7698 93.745 57.8062 92.5563 57.8062C91.3675 57.8062 90.4038 58.7698 90.4038 59.9586C90.4038 61.1474 91.3675 62.1111 92.5563 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 58.8821C87.2875 58.8821 88.2512 57.9184 88.2512 56.7296C88.2512 55.5408 87.2875 54.5771 86.0988 54.5771C84.91 54.5771 83.9463 55.5408 83.9463 56.7296C83.9463 57.9184 84.91 58.8821 86.0988 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0138 52.4246C100.203 52.4246 101.166 51.4609 101.166 50.2721C101.166 49.0833 100.203 48.1196 99.0138 48.1196C97.825 48.1196 96.8613 49.0833 96.8613 50.2721C96.8613 51.4609 97.825 52.4246 99.0138 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 55.6536C93.745 55.6536 94.7087 54.6899 94.7087 53.5011C94.7087 52.3123 93.745 51.3486 92.5563 51.3486C91.3675 51.3486 90.4038 52.3123 90.4038 53.5011C90.4038 54.6899 91.3675 55.6536 92.5563 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 52.4246C87.2875 52.4246 88.2512 51.4609 88.2512 50.2721C88.2512 49.0833 87.2875 48.1196 86.0988 48.1196C84.91 48.1196 83.9463 49.0833 83.9463 50.2721C83.9463 51.4609 84.91 52.4246 86.0988 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5563 49.196C93.745 49.196 94.7087 48.2324 94.7087 47.0436C94.7087 45.8548 93.745 44.8911 92.5563 44.8911C91.3675 44.8911 90.4038 45.8548 90.4038 47.0436C90.4038 48.2324 91.3675 49.196 92.5563 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: -5,
    width: 14,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0984 -4.61572H73.1836V8.29908H86.0984V-4.61572Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 7.2229C87.2875 7.2229 88.2512 6.25921 88.2512 5.07044C88.2512 3.88166 87.2875 2.91797 86.0988 2.91797C84.91 2.91797 83.9463 3.88166 83.9463 5.07044C83.9463 6.25921 84.91 7.2229 86.0988 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 10.4519C80.83 10.4519 81.7937 9.48821 81.7937 8.29944C81.7937 7.11066 80.83 6.14697 79.6412 6.14697C78.4525 6.14697 77.4888 7.11066 77.4888 8.29944C77.4888 9.48821 78.4525 10.4519 79.6412 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 7.2229C74.3725 7.2229 75.3362 6.25921 75.3362 5.07044C75.3362 3.88166 74.3725 2.91797 73.1837 2.91797C71.9949 2.91797 71.0312 3.88166 71.0312 5.07044C71.0312 6.25921 71.9949 7.2229 73.1837 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 0.765382C87.2875 0.765382 88.2512 -0.19831 88.2512 -1.38708C88.2512 -2.57586 87.2875 -3.53955 86.0988 -3.53955C84.91 -3.53955 83.9463 -2.57586 83.9463 -1.38708C83.9463 -0.19831 84.91 0.765382 86.0988 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 3.99439C80.83 3.99439 81.7937 3.03069 81.7937 1.84192C81.7937 0.653145 80.83 -0.310547 79.6412 -0.310547C78.4525 -0.310547 77.4888 0.653145 77.4888 1.84192C77.4888 3.03069 78.4525 3.99439 79.6412 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 0.765382C74.3725 0.765382 75.3362 -0.19831 75.3362 -1.38708C75.3362 -2.57586 74.3725 -3.53955 73.1837 -3.53955C71.9949 -3.53955 71.0312 -2.57586 71.0312 -1.38708C71.0312 -0.19831 71.9949 0.765382 73.1837 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 8,
    width: 14,
    height: 14
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0984 8.29932H73.1836V21.2141H86.0984V8.29932Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 20.1379C87.2875 20.1379 88.2512 19.1742 88.2512 17.9855C88.2512 16.7967 87.2875 15.833 86.0988 15.833C84.91 15.833 83.9463 16.7967 83.9463 17.9855C83.9463 19.1742 84.91 20.1379 86.0988 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 23.3669C80.83 23.3669 81.7937 22.4033 81.7937 21.2145C81.7937 20.0257 80.83 19.062 79.6412 19.062C78.4525 19.062 77.4888 20.0257 77.4888 21.2145C77.4888 22.4033 78.4525 23.3669 79.6412 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 20.1379C74.3725 20.1379 75.3362 19.1742 75.3362 17.9855C75.3362 16.7967 74.3725 15.833 73.1837 15.833C71.9949 15.833 71.0312 16.7967 71.0312 17.9855C71.0312 19.1742 71.9949 20.1379 73.1837 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 13.6804C87.2875 13.6804 88.2512 12.7167 88.2512 11.528C88.2512 10.3392 87.2875 9.37549 86.0988 9.37549C84.91 9.37549 83.9463 10.3392 83.9463 11.528C83.9463 12.7167 84.91 13.6804 86.0988 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 16.9094C80.83 16.9094 81.7937 15.9457 81.7937 14.757C81.7937 13.5682 80.83 12.6045 79.6412 12.6045C78.4525 12.6045 77.4888 13.5682 77.4888 14.757C77.4888 15.9457 78.4525 16.9094 79.6412 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 13.6804C74.3725 13.6804 75.3362 12.7167 75.3362 11.528C75.3362 10.3392 74.3725 9.37549 73.1837 9.37549C71.9949 9.37549 71.0312 10.3392 71.0312 11.528C71.0312 12.7167 71.9949 13.6804 73.1837 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 10.4519C80.83 10.4519 81.7937 9.48821 81.7937 8.29944C81.7937 7.11066 80.83 6.14697 79.6412 6.14697C78.4525 6.14697 77.4888 7.11066 77.4888 8.29944C77.4888 9.48821 78.4525 10.4519 79.6412 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 21,
    width: 14,
    height: 14
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0984 21.2139H73.1836V34.1287H86.0984V21.2139Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 33.0525C87.2875 33.0525 88.2512 32.0888 88.2512 30.9C88.2512 29.7113 87.2875 28.7476 86.0988 28.7476C84.91 28.7476 83.9463 29.7113 83.9463 30.9C83.9463 32.0888 84.91 33.0525 86.0988 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 36.2815C80.83 36.2815 81.7937 35.3178 81.7937 34.129C81.7937 32.9403 80.83 31.9766 79.6412 31.9766C78.4525 31.9766 77.4888 32.9403 77.4888 34.129C77.4888 35.3178 78.4525 36.2815 79.6412 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 33.0525C74.3725 33.0525 75.3362 32.0888 75.3362 30.9C75.3362 29.7113 74.3725 28.7476 73.1837 28.7476C71.9949 28.7476 71.0312 29.7113 71.0312 30.9C71.0312 32.0888 71.9949 33.0525 73.1837 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 26.595C87.2875 26.595 88.2512 25.6313 88.2512 24.4425C88.2512 23.2537 87.2875 22.29 86.0988 22.29C84.91 22.29 83.9463 23.2537 83.9463 24.4425C83.9463 25.6313 84.91 26.595 86.0988 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 29.824C80.83 29.824 81.7937 28.8603 81.7937 27.6715C81.7937 26.4827 80.83 25.519 79.6412 25.519C78.4525 25.519 77.4888 26.4827 77.4888 27.6715C77.4888 28.8603 78.4525 29.824 79.6412 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 26.595C74.3725 26.595 75.3362 25.6313 75.3362 24.4425C75.3362 23.2537 74.3725 22.29 73.1837 22.29C71.9949 22.29 71.0312 23.2537 71.0312 24.4425C71.0312 25.6313 71.9949 26.595 73.1837 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 23.3665C80.83 23.3665 81.7937 22.4028 81.7937 21.214C81.7937 20.0252 80.83 19.0615 79.6412 19.0615C78.4525 19.0615 77.4888 20.0252 77.4888 21.214C77.4888 22.4028 78.4525 23.3665 79.6412 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 34,
    width: 14,
    height: 14
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0984 34.1289H73.1836V47.0437H86.0984V34.1289Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 45.9675C87.2875 45.9675 88.2512 45.0038 88.2512 43.8151C88.2512 42.6263 87.2875 41.6626 86.0988 41.6626C84.91 41.6626 83.9463 42.6263 83.9463 43.8151C83.9463 45.0038 84.91 45.9675 86.0988 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 49.1965C80.83 49.1965 81.7937 48.2328 81.7937 47.0441C81.7937 45.8553 80.83 44.8916 79.6412 44.8916C78.4525 44.8916 77.4888 45.8553 77.4888 47.0441C77.4888 48.2328 78.4525 49.1965 79.6412 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 45.9675C74.3725 45.9675 75.3362 45.0038 75.3362 43.8151C75.3362 42.6263 74.3725 41.6626 73.1837 41.6626C71.9949 41.6626 71.0312 42.6263 71.0312 43.8151C71.0312 45.0038 71.9949 45.9675 73.1837 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 39.51C87.2875 39.51 88.2512 38.5463 88.2512 37.3575C88.2512 36.1688 87.2875 35.2051 86.0988 35.2051C84.91 35.2051 83.9463 36.1688 83.9463 37.3575C83.9463 38.5463 84.91 39.51 86.0988 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 42.739C80.83 42.739 81.7937 41.7753 81.7937 40.5865C81.7937 39.3978 80.83 38.4341 79.6412 38.4341C78.4525 38.4341 77.4888 39.3978 77.4888 40.5865C77.4888 41.7753 78.4525 42.739 79.6412 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 39.51C74.3725 39.51 75.3362 38.5463 75.3362 37.3575C75.3362 36.1688 74.3725 35.2051 73.1837 35.2051C71.9949 35.2051 71.0312 36.1688 71.0312 37.3575C71.0312 38.5463 71.9949 39.51 73.1837 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 36.2815C80.83 36.2815 81.7937 35.3178 81.7937 34.129C81.7937 32.9403 80.83 31.9766 79.6412 31.9766C78.4525 31.9766 77.4888 32.9403 77.4888 34.129C77.4888 35.3178 78.4525 36.2815 79.6412 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 47,
    width: 14,
    height: 13
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0984 47.0435H73.1836V59.9583H86.0984V47.0435Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 58.8821C87.2875 58.8821 88.2512 57.9184 88.2512 56.7296C88.2512 55.5408 87.2875 54.5771 86.0988 54.5771C84.91 54.5771 83.9463 55.5408 83.9463 56.7296C83.9463 57.9184 84.91 58.8821 86.0988 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 62.1111C80.83 62.1111 81.7937 61.1474 81.7937 59.9586C81.7937 58.7698 80.83 57.8062 79.6412 57.8062C78.4525 57.8062 77.4888 58.7698 77.4888 59.9586C77.4888 61.1474 78.4525 62.1111 79.6412 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 58.8821C74.3725 58.8821 75.3362 57.9184 75.3362 56.7296C75.3362 55.5408 74.3725 54.5771 73.1837 54.5771C71.9949 54.5771 71.0312 55.5408 71.0312 56.7296C71.0312 57.9184 71.9949 58.8821 73.1837 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0988 52.4246C87.2875 52.4246 88.2512 51.4609 88.2512 50.2721C88.2512 49.0833 87.2875 48.1196 86.0988 48.1196C84.91 48.1196 83.9463 49.0833 83.9463 50.2721C83.9463 51.4609 84.91 52.4246 86.0988 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 55.6536C80.83 55.6536 81.7937 54.6899 81.7937 53.5011C81.7937 52.3123 80.83 51.3486 79.6412 51.3486C78.4525 51.3486 77.4888 52.3123 77.4888 53.5011C77.4888 54.6899 78.4525 55.6536 79.6412 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1837 52.4246C74.3725 52.4246 75.3362 51.4609 75.3362 50.2721C75.3362 49.0833 74.3725 48.1196 73.1837 48.1196C71.9949 48.1196 71.0312 49.0833 71.0312 50.2721C71.0312 51.4609 71.9949 52.4246 73.1837 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 49.196C80.83 49.196 81.7937 48.2324 81.7937 47.0436C81.7937 45.8548 80.83 44.8911 79.6412 44.8911C78.4525 44.8911 77.4888 45.8548 77.4888 47.0436C77.4888 48.2324 78.4525 49.196 79.6412 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: -5,
    width: 14,
    height: 14
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1838 -4.61572H60.269V8.29908H73.1838V-4.61572Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 7.2229C74.373 7.2229 75.3367 6.25921 75.3367 5.07044C75.3367 3.88166 74.373 2.91797 73.1842 2.91797C71.9954 2.91797 71.0317 3.88166 71.0317 5.07044C71.0317 6.25921 71.9954 7.2229 73.1842 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 10.4519C67.9155 10.4519 68.8792 9.48821 68.8792 8.29944C68.8792 7.11066 67.9155 6.14697 66.7267 6.14697C65.5379 6.14697 64.5742 7.11066 64.5742 8.29944C64.5742 9.48821 65.5379 10.4519 66.7267 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 7.2229C61.4579 7.2229 62.4216 6.25921 62.4216 5.07044C62.4216 3.88166 61.4579 2.91797 60.2692 2.91797C59.0804 2.91797 58.1167 3.88166 58.1167 5.07044C58.1167 6.25921 59.0804 7.2229 60.2692 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 0.765382C74.373 0.765382 75.3367 -0.19831 75.3367 -1.38708C75.3367 -2.57586 74.373 -3.53955 73.1842 -3.53955C71.9954 -3.53955 71.0317 -2.57586 71.0317 -1.38708C71.0317 -0.19831 71.9954 0.765382 73.1842 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 3.99439C67.9155 3.99439 68.8792 3.03069 68.8792 1.84192C68.8792 0.653145 67.9155 -0.310547 66.7267 -0.310547C65.5379 -0.310547 64.5742 0.653145 64.5742 1.84192C64.5742 3.03069 65.5379 3.99439 66.7267 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 0.765382C61.4579 0.765382 62.4216 -0.19831 62.4216 -1.38708C62.4216 -2.57586 61.4579 -3.53955 60.2692 -3.53955C59.0804 -3.53955 58.1167 -2.57586 58.1167 -1.38708C58.1167 -0.19831 59.0804 0.765382 60.2692 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 8,
    width: 14,
    height: 14
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1838 8.29932H60.269V21.2141H73.1838V8.29932Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 20.1379C74.373 20.1379 75.3367 19.1742 75.3367 17.9855C75.3367 16.7967 74.373 15.833 73.1842 15.833C71.9954 15.833 71.0317 16.7967 71.0317 17.9855C71.0317 19.1742 71.9954 20.1379 73.1842 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 23.3669C67.9155 23.3669 68.8792 22.4033 68.8792 21.2145C68.8792 20.0257 67.9155 19.062 66.7267 19.062C65.5379 19.062 64.5742 20.0257 64.5742 21.2145C64.5742 22.4033 65.5379 23.3669 66.7267 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 20.1379C61.4579 20.1379 62.4216 19.1742 62.4216 17.9855C62.4216 16.7967 61.4579 15.833 60.2692 15.833C59.0804 15.833 58.1167 16.7967 58.1167 17.9855C58.1167 19.1742 59.0804 20.1379 60.2692 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 13.6804C74.373 13.6804 75.3367 12.7167 75.3367 11.528C75.3367 10.3392 74.373 9.37549 73.1842 9.37549C71.9954 9.37549 71.0317 10.3392 71.0317 11.528C71.0317 12.7167 71.9954 13.6804 73.1842 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 16.9094C67.9155 16.9094 68.8792 15.9457 68.8792 14.757C68.8792 13.5682 67.9155 12.6045 66.7267 12.6045C65.5379 12.6045 64.5742 13.5682 64.5742 14.757C64.5742 15.9457 65.5379 16.9094 66.7267 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 13.6804C61.4579 13.6804 62.4216 12.7167 62.4216 11.528C62.4216 10.3392 61.4579 9.37549 60.2692 9.37549C59.0804 9.37549 58.1167 10.3392 58.1167 11.528C58.1167 12.7167 59.0804 13.6804 60.2692 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 10.4519C67.9155 10.4519 68.8792 9.48821 68.8792 8.29944C68.8792 7.11066 67.9155 6.14697 66.7267 6.14697C65.5379 6.14697 64.5742 7.11066 64.5742 8.29944C64.5742 9.48821 65.5379 10.4519 66.7267 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 21,
    width: 14,
    height: 14
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1838 21.2139H60.269V34.1287H73.1838V21.2139Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 33.0525C74.373 33.0525 75.3367 32.0888 75.3367 30.9C75.3367 29.7113 74.373 28.7476 73.1842 28.7476C71.9954 28.7476 71.0317 29.7113 71.0317 30.9C71.0317 32.0888 71.9954 33.0525 73.1842 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 36.2815C67.9155 36.2815 68.8792 35.3178 68.8792 34.129C68.8792 32.9403 67.9155 31.9766 66.7267 31.9766C65.5379 31.9766 64.5742 32.9403 64.5742 34.129C64.5742 35.3178 65.5379 36.2815 66.7267 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 33.0525C61.4579 33.0525 62.4216 32.0888 62.4216 30.9C62.4216 29.7113 61.4579 28.7476 60.2692 28.7476C59.0804 28.7476 58.1167 29.7113 58.1167 30.9C58.1167 32.0888 59.0804 33.0525 60.2692 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 26.595C74.373 26.595 75.3367 25.6313 75.3367 24.4425C75.3367 23.2537 74.373 22.29 73.1842 22.29C71.9954 22.29 71.0317 23.2537 71.0317 24.4425C71.0317 25.6313 71.9954 26.595 73.1842 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 29.824C67.9155 29.824 68.8792 28.8603 68.8792 27.6715C68.8792 26.4827 67.9155 25.519 66.7267 25.519C65.5379 25.519 64.5742 26.4827 64.5742 27.6715C64.5742 28.8603 65.5379 29.824 66.7267 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 26.595C61.4579 26.595 62.4216 25.6313 62.4216 24.4425C62.4216 23.2537 61.4579 22.29 60.2692 22.29C59.0804 22.29 58.1167 23.2537 58.1167 24.4425C58.1167 25.6313 59.0804 26.595 60.2692 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 23.3665C67.9155 23.3665 68.8792 22.4028 68.8792 21.214C68.8792 20.0252 67.9155 19.0615 66.7267 19.0615C65.5379 19.0615 64.5742 20.0252 64.5742 21.214C64.5742 22.4028 65.5379 23.3665 66.7267 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 34,
    width: 14,
    height: 14
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1838 34.1289H60.269V47.0437H73.1838V34.1289Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 45.9675C74.373 45.9675 75.3367 45.0038 75.3367 43.8151C75.3367 42.6263 74.373 41.6626 73.1842 41.6626C71.9954 41.6626 71.0317 42.6263 71.0317 43.8151C71.0317 45.0038 71.9954 45.9675 73.1842 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 49.1965C67.9155 49.1965 68.8792 48.2328 68.8792 47.0441C68.8792 45.8553 67.9155 44.8916 66.7267 44.8916C65.5379 44.8916 64.5742 45.8553 64.5742 47.0441C64.5742 48.2328 65.5379 49.1965 66.7267 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 45.9675C61.4579 45.9675 62.4216 45.0038 62.4216 43.8151C62.4216 42.6263 61.4579 41.6626 60.2692 41.6626C59.0804 41.6626 58.1167 42.6263 58.1167 43.8151C58.1167 45.0038 59.0804 45.9675 60.2692 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 39.51C74.373 39.51 75.3367 38.5463 75.3367 37.3575C75.3367 36.1688 74.373 35.2051 73.1842 35.2051C71.9954 35.2051 71.0317 36.1688 71.0317 37.3575C71.0317 38.5463 71.9954 39.51 73.1842 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 42.739C67.9155 42.739 68.8792 41.7753 68.8792 40.5865C68.8792 39.3978 67.9155 38.4341 66.7267 38.4341C65.5379 38.4341 64.5742 39.3978 64.5742 40.5865C64.5742 41.7753 65.5379 42.739 66.7267 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 39.51C61.4579 39.51 62.4216 38.5463 62.4216 37.3575C62.4216 36.1688 61.4579 35.2051 60.2692 35.2051C59.0804 35.2051 58.1167 36.1688 58.1167 37.3575C58.1167 38.5463 59.0804 39.51 60.2692 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 36.2815C67.9155 36.2815 68.8792 35.3178 68.8792 34.129C68.8792 32.9403 67.9155 31.9766 66.7267 31.9766C65.5379 31.9766 64.5742 32.9403 64.5742 34.129C64.5742 35.3178 65.5379 36.2815 66.7267 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 47,
    width: 14,
    height: 13
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1838 47.0435H60.269V59.9583H73.1838V47.0435Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 58.8821C74.373 58.8821 75.3367 57.9184 75.3367 56.7296C75.3367 55.5408 74.373 54.5771 73.1842 54.5771C71.9954 54.5771 71.0317 55.5408 71.0317 56.7296C71.0317 57.9184 71.9954 58.8821 73.1842 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 62.1111C67.9155 62.1111 68.8792 61.1474 68.8792 59.9586C68.8792 58.7698 67.9155 57.8062 66.7267 57.8062C65.5379 57.8062 64.5742 58.7698 64.5742 59.9586C64.5742 61.1474 65.5379 62.1111 66.7267 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 58.8821C61.4579 58.8821 62.4216 57.9184 62.4216 56.7296C62.4216 55.5408 61.4579 54.5771 60.2692 54.5771C59.0804 54.5771 58.1167 55.5408 58.1167 56.7296C58.1167 57.9184 59.0804 58.8821 60.2692 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1842 52.4246C74.373 52.4246 75.3367 51.4609 75.3367 50.2721C75.3367 49.0833 74.373 48.1196 73.1842 48.1196C71.9954 48.1196 71.0317 49.0833 71.0317 50.2721C71.0317 51.4609 71.9954 52.4246 73.1842 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 55.6536C67.9155 55.6536 68.8792 54.6899 68.8792 53.5011C68.8792 52.3123 67.9155 51.3486 66.7267 51.3486C65.5379 51.3486 64.5742 52.3123 64.5742 53.5011C64.5742 54.6899 65.5379 55.6536 66.7267 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 52.4246C61.4579 52.4246 62.4216 51.4609 62.4216 50.2721C62.4216 49.0833 61.4579 48.1196 60.2692 48.1196C59.0804 48.1196 58.1167 49.0833 58.1167 50.2721C58.1167 51.4609 59.0804 52.4246 60.2692 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7267 49.196C67.9155 49.196 68.8792 48.2324 68.8792 47.0436C68.8792 45.8548 67.9155 44.8911 66.7267 44.8911C65.5379 44.8911 64.5742 45.8548 64.5742 47.0436C64.5742 48.2324 65.5379 49.196 66.7267 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: -5,
    width: 14,
    height: 14
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2688 -4.61572H47.354V8.29908H60.2688V-4.61572Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 7.2229C61.4579 7.2229 62.4216 6.25921 62.4216 5.07044C62.4216 3.88166 61.4579 2.91797 60.2692 2.91797C59.0804 2.91797 58.1167 3.88166 58.1167 5.07044C58.1167 6.25921 59.0804 7.2229 60.2692 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 10.4519C55.0004 10.4519 55.9641 9.48821 55.9641 8.29944C55.9641 7.11066 55.0004 6.14697 53.8116 6.14697C52.6229 6.14697 51.6592 7.11066 51.6592 8.29944C51.6592 9.48821 52.6229 10.4519 53.8116 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 7.2229C48.5429 7.2229 49.5066 6.25921 49.5066 5.07044C49.5066 3.88166 48.5429 2.91797 47.3541 2.91797C46.1654 2.91797 45.2017 3.88166 45.2017 5.07044C45.2017 6.25921 46.1654 7.2229 47.3541 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 0.765382C61.4579 0.765382 62.4216 -0.19831 62.4216 -1.38708C62.4216 -2.57586 61.4579 -3.53955 60.2692 -3.53955C59.0804 -3.53955 58.1167 -2.57586 58.1167 -1.38708C58.1167 -0.19831 59.0804 0.765382 60.2692 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 3.99439C55.0004 3.99439 55.9641 3.03069 55.9641 1.84192C55.9641 0.653145 55.0004 -0.310547 53.8116 -0.310547C52.6229 -0.310547 51.6592 0.653145 51.6592 1.84192C51.6592 3.03069 52.6229 3.99439 53.8116 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 0.765382C48.5429 0.765382 49.5066 -0.19831 49.5066 -1.38708C49.5066 -2.57586 48.5429 -3.53955 47.3541 -3.53955C46.1654 -3.53955 45.2017 -2.57586 45.2017 -1.38708C45.2017 -0.19831 46.1654 0.765382 47.3541 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 8,
    width: 14,
    height: 14
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2688 8.29932H47.354V21.2141H60.2688V8.29932Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 20.1379C61.4579 20.1379 62.4216 19.1742 62.4216 17.9855C62.4216 16.7967 61.4579 15.833 60.2692 15.833C59.0804 15.833 58.1167 16.7967 58.1167 17.9855C58.1167 19.1742 59.0804 20.1379 60.2692 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 23.3669C55.0004 23.3669 55.9641 22.4033 55.9641 21.2145C55.9641 20.0257 55.0004 19.062 53.8116 19.062C52.6229 19.062 51.6592 20.0257 51.6592 21.2145C51.6592 22.4033 52.6229 23.3669 53.8116 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 20.1379C48.5429 20.1379 49.5066 19.1742 49.5066 17.9855C49.5066 16.7967 48.5429 15.833 47.3541 15.833C46.1654 15.833 45.2017 16.7967 45.2017 17.9855C45.2017 19.1742 46.1654 20.1379 47.3541 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 13.6804C61.4579 13.6804 62.4216 12.7167 62.4216 11.528C62.4216 10.3392 61.4579 9.37549 60.2692 9.37549C59.0804 9.37549 58.1167 10.3392 58.1167 11.528C58.1167 12.7167 59.0804 13.6804 60.2692 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 16.9094C55.0004 16.9094 55.9641 15.9457 55.9641 14.757C55.9641 13.5682 55.0004 12.6045 53.8116 12.6045C52.6229 12.6045 51.6592 13.5682 51.6592 14.757C51.6592 15.9457 52.6229 16.9094 53.8116 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 13.6804C48.5429 13.6804 49.5066 12.7167 49.5066 11.528C49.5066 10.3392 48.5429 9.37549 47.3541 9.37549C46.1654 9.37549 45.2017 10.3392 45.2017 11.528C45.2017 12.7167 46.1654 13.6804 47.3541 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 10.4519C55.0004 10.4519 55.9641 9.48821 55.9641 8.29944C55.9641 7.11066 55.0004 6.14697 53.8116 6.14697C52.6229 6.14697 51.6592 7.11066 51.6592 8.29944C51.6592 9.48821 52.6229 10.4519 53.8116 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 21,
    width: 14,
    height: 14
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2688 21.2139H47.354V34.1287H60.2688V21.2139Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 33.0525C61.4579 33.0525 62.4216 32.0888 62.4216 30.9C62.4216 29.7113 61.4579 28.7476 60.2692 28.7476C59.0804 28.7476 58.1167 29.7113 58.1167 30.9C58.1167 32.0888 59.0804 33.0525 60.2692 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 36.2815C55.0004 36.2815 55.9641 35.3178 55.9641 34.129C55.9641 32.9403 55.0004 31.9766 53.8116 31.9766C52.6229 31.9766 51.6592 32.9403 51.6592 34.129C51.6592 35.3178 52.6229 36.2815 53.8116 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 33.0525C48.5429 33.0525 49.5066 32.0888 49.5066 30.9C49.5066 29.7113 48.5429 28.7476 47.3541 28.7476C46.1654 28.7476 45.2017 29.7113 45.2017 30.9C45.2017 32.0888 46.1654 33.0525 47.3541 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 26.595C61.4579 26.595 62.4216 25.6313 62.4216 24.4425C62.4216 23.2537 61.4579 22.29 60.2692 22.29C59.0804 22.29 58.1167 23.2537 58.1167 24.4425C58.1167 25.6313 59.0804 26.595 60.2692 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 29.824C55.0004 29.824 55.9641 28.8603 55.9641 27.6715C55.9641 26.4827 55.0004 25.519 53.8116 25.519C52.6229 25.519 51.6592 26.4827 51.6592 27.6715C51.6592 28.8603 52.6229 29.824 53.8116 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 26.595C48.5429 26.595 49.5066 25.6313 49.5066 24.4425C49.5066 23.2537 48.5429 22.29 47.3541 22.29C46.1654 22.29 45.2017 23.2537 45.2017 24.4425C45.2017 25.6313 46.1654 26.595 47.3541 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 23.3665C55.0004 23.3665 55.9641 22.4028 55.9641 21.214C55.9641 20.0252 55.0004 19.0615 53.8116 19.0615C52.6229 19.0615 51.6592 20.0252 51.6592 21.214C51.6592 22.4028 52.6229 23.3665 53.8116 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 34,
    width: 14,
    height: 14
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2688 34.1289H47.354V47.0437H60.2688V34.1289Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 45.9675C61.4579 45.9675 62.4216 45.0038 62.4216 43.8151C62.4216 42.6263 61.4579 41.6626 60.2692 41.6626C59.0804 41.6626 58.1167 42.6263 58.1167 43.8151C58.1167 45.0038 59.0804 45.9675 60.2692 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 49.1965C55.0004 49.1965 55.9641 48.2328 55.9641 47.0441C55.9641 45.8553 55.0004 44.8916 53.8116 44.8916C52.6229 44.8916 51.6592 45.8553 51.6592 47.0441C51.6592 48.2328 52.6229 49.1965 53.8116 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 45.9675C48.5429 45.9675 49.5066 45.0038 49.5066 43.8151C49.5066 42.6263 48.5429 41.6626 47.3541 41.6626C46.1654 41.6626 45.2017 42.6263 45.2017 43.8151C45.2017 45.0038 46.1654 45.9675 47.3541 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 39.51C61.4579 39.51 62.4216 38.5463 62.4216 37.3575C62.4216 36.1688 61.4579 35.2051 60.2692 35.2051C59.0804 35.2051 58.1167 36.1688 58.1167 37.3575C58.1167 38.5463 59.0804 39.51 60.2692 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 42.739C55.0004 42.739 55.9641 41.7753 55.9641 40.5865C55.9641 39.3978 55.0004 38.4341 53.8116 38.4341C52.6229 38.4341 51.6592 39.3978 51.6592 40.5865C51.6592 41.7753 52.6229 42.739 53.8116 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 39.51C48.5429 39.51 49.5066 38.5463 49.5066 37.3575C49.5066 36.1688 48.5429 35.2051 47.3541 35.2051C46.1654 35.2051 45.2017 36.1688 45.2017 37.3575C45.2017 38.5463 46.1654 39.51 47.3541 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 36.2815C55.0004 36.2815 55.9641 35.3178 55.9641 34.129C55.9641 32.9403 55.0004 31.9766 53.8116 31.9766C52.6229 31.9766 51.6592 32.9403 51.6592 34.129C51.6592 35.3178 52.6229 36.2815 53.8116 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 47,
    width: 14,
    height: 13
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2688 47.0435H47.354V59.9583H60.2688V47.0435Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 58.8821C61.4579 58.8821 62.4216 57.9184 62.4216 56.7296C62.4216 55.5408 61.4579 54.5771 60.2692 54.5771C59.0804 54.5771 58.1167 55.5408 58.1167 56.7296C58.1167 57.9184 59.0804 58.8821 60.2692 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 62.1111C55.0004 62.1111 55.9641 61.1474 55.9641 59.9586C55.9641 58.7698 55.0004 57.8062 53.8116 57.8062C52.6229 57.8062 51.6592 58.7698 51.6592 59.9586C51.6592 61.1474 52.6229 62.1111 53.8116 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 58.8821C48.5429 58.8821 49.5066 57.9184 49.5066 56.7296C49.5066 55.5408 48.5429 54.5771 47.3541 54.5771C46.1654 54.5771 45.2017 55.5408 45.2017 56.7296C45.2017 57.9184 46.1654 58.8821 47.3541 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2692 52.4246C61.4579 52.4246 62.4216 51.4609 62.4216 50.2721C62.4216 49.0833 61.4579 48.1196 60.2692 48.1196C59.0804 48.1196 58.1167 49.0833 58.1167 50.2721C58.1167 51.4609 59.0804 52.4246 60.2692 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 55.6536C55.0004 55.6536 55.9641 54.6899 55.9641 53.5011C55.9641 52.3123 55.0004 51.3486 53.8116 51.3486C52.6229 51.3486 51.6592 52.3123 51.6592 53.5011C51.6592 54.6899 52.6229 55.6536 53.8116 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3541 52.4246C48.5429 52.4246 49.5066 51.4609 49.5066 50.2721C49.5066 49.0833 48.5429 48.1196 47.3541 48.1196C46.1654 48.1196 45.2017 49.0833 45.2017 50.2721C45.2017 51.4609 46.1654 52.4246 47.3541 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8116 49.196C55.0004 49.196 55.9641 48.2324 55.9641 47.0436C55.9641 45.8548 55.0004 44.8911 53.8116 44.8911C52.6229 44.8911 51.6592 45.8548 51.6592 47.0436C51.6592 48.2324 52.6229 49.196 53.8116 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: -5,
    width: 14,
    height: 14
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3543 -4.61572H34.4395V8.29908H47.3543V-4.61572Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 7.2229C48.5434 7.2229 49.5071 6.25921 49.5071 5.07044C49.5071 3.88166 48.5434 2.91797 47.3546 2.91797C46.1658 2.91797 45.2021 3.88166 45.2021 5.07044C45.2021 6.25921 46.1658 7.2229 47.3546 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 10.4519C42.0859 10.4519 43.0496 9.48821 43.0496 8.29944C43.0496 7.11066 42.0859 6.14697 40.8971 6.14697C39.7083 6.14697 38.7446 7.11066 38.7446 8.29944C38.7446 9.48821 39.7083 10.4519 40.8971 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 7.2229C35.6284 7.2229 36.592 6.25921 36.592 5.07044C36.592 3.88166 35.6284 2.91797 34.4396 2.91797C33.2508 2.91797 32.2871 3.88166 32.2871 5.07044C32.2871 6.25921 33.2508 7.2229 34.4396 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 0.765382C48.5434 0.765382 49.5071 -0.19831 49.5071 -1.38708C49.5071 -2.57586 48.5434 -3.53955 47.3546 -3.53955C46.1658 -3.53955 45.2021 -2.57586 45.2021 -1.38708C45.2021 -0.19831 46.1658 0.765382 47.3546 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 3.99439C42.0859 3.99439 43.0496 3.03069 43.0496 1.84192C43.0496 0.653145 42.0859 -0.310547 40.8971 -0.310547C39.7083 -0.310547 38.7446 0.653145 38.7446 1.84192C38.7446 3.03069 39.7083 3.99439 40.8971 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 0.765382C35.6284 0.765382 36.592 -0.19831 36.592 -1.38708C36.592 -2.57586 35.6284 -3.53955 34.4396 -3.53955C33.2508 -3.53955 32.2871 -2.57586 32.2871 -1.38708C32.2871 -0.19831 33.2508 0.765382 34.4396 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 8,
    width: 14,
    height: 14
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3543 8.29932H34.4395V21.2141H47.3543V8.29932Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 20.1379C48.5434 20.1379 49.5071 19.1742 49.5071 17.9855C49.5071 16.7967 48.5434 15.833 47.3546 15.833C46.1658 15.833 45.2021 16.7967 45.2021 17.9855C45.2021 19.1742 46.1658 20.1379 47.3546 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 23.3669C42.0859 23.3669 43.0496 22.4033 43.0496 21.2145C43.0496 20.0257 42.0859 19.062 40.8971 19.062C39.7083 19.062 38.7446 20.0257 38.7446 21.2145C38.7446 22.4033 39.7083 23.3669 40.8971 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 20.1379C35.6284 20.1379 36.592 19.1742 36.592 17.9855C36.592 16.7967 35.6284 15.833 34.4396 15.833C33.2508 15.833 32.2871 16.7967 32.2871 17.9855C32.2871 19.1742 33.2508 20.1379 34.4396 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 13.6804C48.5434 13.6804 49.5071 12.7167 49.5071 11.528C49.5071 10.3392 48.5434 9.37549 47.3546 9.37549C46.1658 9.37549 45.2021 10.3392 45.2021 11.528C45.2021 12.7167 46.1658 13.6804 47.3546 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 16.9094C42.0859 16.9094 43.0496 15.9457 43.0496 14.757C43.0496 13.5682 42.0859 12.6045 40.8971 12.6045C39.7083 12.6045 38.7446 13.5682 38.7446 14.757C38.7446 15.9457 39.7083 16.9094 40.8971 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 13.6804C35.6284 13.6804 36.592 12.7167 36.592 11.528C36.592 10.3392 35.6284 9.37549 34.4396 9.37549C33.2508 9.37549 32.2871 10.3392 32.2871 11.528C32.2871 12.7167 33.2508 13.6804 34.4396 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 10.4519C42.0859 10.4519 43.0496 9.48821 43.0496 8.29944C43.0496 7.11066 42.0859 6.14697 40.8971 6.14697C39.7083 6.14697 38.7446 7.11066 38.7446 8.29944C38.7446 9.48821 39.7083 10.4519 40.8971 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 21,
    width: 14,
    height: 14
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3543 21.2139H34.4395V34.1287H47.3543V21.2139Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 33.0525C48.5434 33.0525 49.5071 32.0888 49.5071 30.9C49.5071 29.7113 48.5434 28.7476 47.3546 28.7476C46.1658 28.7476 45.2021 29.7113 45.2021 30.9C45.2021 32.0888 46.1658 33.0525 47.3546 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 36.2815C42.0859 36.2815 43.0496 35.3178 43.0496 34.129C43.0496 32.9403 42.0859 31.9766 40.8971 31.9766C39.7083 31.9766 38.7446 32.9403 38.7446 34.129C38.7446 35.3178 39.7083 36.2815 40.8971 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 33.0525C35.6284 33.0525 36.592 32.0888 36.592 30.9C36.592 29.7113 35.6284 28.7476 34.4396 28.7476C33.2508 28.7476 32.2871 29.7113 32.2871 30.9C32.2871 32.0888 33.2508 33.0525 34.4396 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 26.595C48.5434 26.595 49.5071 25.6313 49.5071 24.4425C49.5071 23.2537 48.5434 22.29 47.3546 22.29C46.1658 22.29 45.2021 23.2537 45.2021 24.4425C45.2021 25.6313 46.1658 26.595 47.3546 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 29.824C42.0859 29.824 43.0496 28.8603 43.0496 27.6715C43.0496 26.4827 42.0859 25.519 40.8971 25.519C39.7083 25.519 38.7446 26.4827 38.7446 27.6715C38.7446 28.8603 39.7083 29.824 40.8971 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 26.595C35.6284 26.595 36.592 25.6313 36.592 24.4425C36.592 23.2537 35.6284 22.29 34.4396 22.29C33.2508 22.29 32.2871 23.2537 32.2871 24.4425C32.2871 25.6313 33.2508 26.595 34.4396 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 23.3665C42.0859 23.3665 43.0496 22.4028 43.0496 21.214C43.0496 20.0252 42.0859 19.0615 40.8971 19.0615C39.7083 19.0615 38.7446 20.0252 38.7446 21.214C38.7446 22.4028 39.7083 23.3665 40.8971 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 34,
    width: 14,
    height: 14
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3543 34.1289H34.4395V47.0437H47.3543V34.1289Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 45.9675C48.5434 45.9675 49.5071 45.0038 49.5071 43.8151C49.5071 42.6263 48.5434 41.6626 47.3546 41.6626C46.1658 41.6626 45.2021 42.6263 45.2021 43.8151C45.2021 45.0038 46.1658 45.9675 47.3546 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 49.1965C42.0859 49.1965 43.0496 48.2328 43.0496 47.0441C43.0496 45.8553 42.0859 44.8916 40.8971 44.8916C39.7083 44.8916 38.7446 45.8553 38.7446 47.0441C38.7446 48.2328 39.7083 49.1965 40.8971 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 45.9675C35.6284 45.9675 36.592 45.0038 36.592 43.8151C36.592 42.6263 35.6284 41.6626 34.4396 41.6626C33.2508 41.6626 32.2871 42.6263 32.2871 43.8151C32.2871 45.0038 33.2508 45.9675 34.4396 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 39.51C48.5434 39.51 49.5071 38.5463 49.5071 37.3575C49.5071 36.1688 48.5434 35.2051 47.3546 35.2051C46.1658 35.2051 45.2021 36.1688 45.2021 37.3575C45.2021 38.5463 46.1658 39.51 47.3546 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 42.739C42.0859 42.739 43.0496 41.7753 43.0496 40.5865C43.0496 39.3978 42.0859 38.4341 40.8971 38.4341C39.7083 38.4341 38.7446 39.3978 38.7446 40.5865C38.7446 41.7753 39.7083 42.739 40.8971 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 39.51C35.6284 39.51 36.592 38.5463 36.592 37.3575C36.592 36.1688 35.6284 35.2051 34.4396 35.2051C33.2508 35.2051 32.2871 36.1688 32.2871 37.3575C32.2871 38.5463 33.2508 39.51 34.4396 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 36.2815C42.0859 36.2815 43.0496 35.3178 43.0496 34.129C43.0496 32.9403 42.0859 31.9766 40.8971 31.9766C39.7083 31.9766 38.7446 32.9403 38.7446 34.129C38.7446 35.3178 39.7083 36.2815 40.8971 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 47,
    width: 14,
    height: 13
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3543 47.0435H34.4395V59.9583H47.3543V47.0435Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 58.8821C48.5434 58.8821 49.5071 57.9184 49.5071 56.7296C49.5071 55.5408 48.5434 54.5771 47.3546 54.5771C46.1658 54.5771 45.2021 55.5408 45.2021 56.7296C45.2021 57.9184 46.1658 58.8821 47.3546 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 62.1111C42.0859 62.1111 43.0496 61.1474 43.0496 59.9586C43.0496 58.7698 42.0859 57.8062 40.8971 57.8062C39.7083 57.8062 38.7446 58.7698 38.7446 59.9586C38.7446 61.1474 39.7083 62.1111 40.8971 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 58.8821C35.6284 58.8821 36.592 57.9184 36.592 56.7296C36.592 55.5408 35.6284 54.5771 34.4396 54.5771C33.2508 54.5771 32.2871 55.5408 32.2871 56.7296C32.2871 57.9184 33.2508 58.8821 34.4396 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3546 52.4246C48.5434 52.4246 49.5071 51.4609 49.5071 50.2721C49.5071 49.0833 48.5434 48.1196 47.3546 48.1196C46.1658 48.1196 45.2021 49.0833 45.2021 50.2721C45.2021 51.4609 46.1658 52.4246 47.3546 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 55.6536C42.0859 55.6536 43.0496 54.6899 43.0496 53.5011C43.0496 52.3123 42.0859 51.3486 40.8971 51.3486C39.7083 51.3486 38.7446 52.3123 38.7446 53.5011C38.7446 54.6899 39.7083 55.6536 40.8971 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 52.4246C35.6284 52.4246 36.592 51.4609 36.592 50.2721C36.592 49.0833 35.6284 48.1196 34.4396 48.1196C33.2508 48.1196 32.2871 49.0833 32.2871 50.2721C32.2871 51.4609 33.2508 52.4246 34.4396 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8971 49.196C42.0859 49.196 43.0496 48.2324 43.0496 47.0436C43.0496 45.8548 42.0859 44.8911 40.8971 44.8911C39.7083 44.8911 38.7446 45.8548 38.7446 47.0436C38.7446 48.2324 39.7083 49.196 40.8971 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: -5,
    width: 14,
    height: 14
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4392 -4.61572H21.5244V8.29908H34.4392V-4.61572Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 7.2229C35.6284 7.2229 36.592 6.25921 36.592 5.07044C36.592 3.88166 35.6284 2.91797 34.4396 2.91797C33.2508 2.91797 32.2871 3.88166 32.2871 5.07044C32.2871 6.25921 33.2508 7.2229 34.4396 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 10.4519C29.1708 10.4519 30.1345 9.48821 30.1345 8.29944C30.1345 7.11066 29.1708 6.14697 27.9821 6.14697C26.7933 6.14697 25.8296 7.11066 25.8296 8.29944C25.8296 9.48821 26.7933 10.4519 27.9821 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 7.2229C22.7133 7.2229 23.677 6.25921 23.677 5.07044C23.677 3.88166 22.7133 2.91797 21.5245 2.91797C20.3358 2.91797 19.3721 3.88166 19.3721 5.07044C19.3721 6.25921 20.3358 7.2229 21.5245 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 0.765382C35.6284 0.765382 36.592 -0.19831 36.592 -1.38708C36.592 -2.57586 35.6284 -3.53955 34.4396 -3.53955C33.2508 -3.53955 32.2871 -2.57586 32.2871 -1.38708C32.2871 -0.19831 33.2508 0.765382 34.4396 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 3.99439C29.1708 3.99439 30.1345 3.03069 30.1345 1.84192C30.1345 0.653145 29.1708 -0.310547 27.9821 -0.310547C26.7933 -0.310547 25.8296 0.653145 25.8296 1.84192C25.8296 3.03069 26.7933 3.99439 27.9821 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 0.765382C22.7133 0.765382 23.677 -0.19831 23.677 -1.38708C23.677 -2.57586 22.7133 -3.53955 21.5245 -3.53955C20.3358 -3.53955 19.3721 -2.57586 19.3721 -1.38708C19.3721 -0.19831 20.3358 0.765382 21.5245 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 8,
    width: 14,
    height: 14
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4392 8.29932H21.5244V21.2141H34.4392V8.29932Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 20.1379C35.6284 20.1379 36.592 19.1742 36.592 17.9855C36.592 16.7967 35.6284 15.833 34.4396 15.833C33.2508 15.833 32.2871 16.7967 32.2871 17.9855C32.2871 19.1742 33.2508 20.1379 34.4396 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 23.3669C29.1708 23.3669 30.1345 22.4033 30.1345 21.2145C30.1345 20.0257 29.1708 19.062 27.9821 19.062C26.7933 19.062 25.8296 20.0257 25.8296 21.2145C25.8296 22.4033 26.7933 23.3669 27.9821 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 20.1379C22.7133 20.1379 23.677 19.1742 23.677 17.9855C23.677 16.7967 22.7133 15.833 21.5245 15.833C20.3358 15.833 19.3721 16.7967 19.3721 17.9855C19.3721 19.1742 20.3358 20.1379 21.5245 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 13.6804C35.6284 13.6804 36.592 12.7167 36.592 11.528C36.592 10.3392 35.6284 9.37549 34.4396 9.37549C33.2508 9.37549 32.2871 10.3392 32.2871 11.528C32.2871 12.7167 33.2508 13.6804 34.4396 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 16.9094C29.1708 16.9094 30.1345 15.9457 30.1345 14.757C30.1345 13.5682 29.1708 12.6045 27.9821 12.6045C26.7933 12.6045 25.8296 13.5682 25.8296 14.757C25.8296 15.9457 26.7933 16.9094 27.9821 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 13.6804C22.7133 13.6804 23.677 12.7167 23.677 11.528C23.677 10.3392 22.7133 9.37549 21.5245 9.37549C20.3358 9.37549 19.3721 10.3392 19.3721 11.528C19.3721 12.7167 20.3358 13.6804 21.5245 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 10.4519C29.1708 10.4519 30.1345 9.48821 30.1345 8.29944C30.1345 7.11066 29.1708 6.14697 27.9821 6.14697C26.7933 6.14697 25.8296 7.11066 25.8296 8.29944C25.8296 9.48821 26.7933 10.4519 27.9821 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 14,
    height: 14
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4392 21.2139H21.5244V34.1287H34.4392V21.2139Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 33.0525C35.6284 33.0525 36.592 32.0888 36.592 30.9C36.592 29.7113 35.6284 28.7476 34.4396 28.7476C33.2508 28.7476 32.2871 29.7113 32.2871 30.9C32.2871 32.0888 33.2508 33.0525 34.4396 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 36.2815C29.1708 36.2815 30.1345 35.3178 30.1345 34.129C30.1345 32.9403 29.1708 31.9766 27.9821 31.9766C26.7933 31.9766 25.8296 32.9403 25.8296 34.129C25.8296 35.3178 26.7933 36.2815 27.9821 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 33.0525C22.7133 33.0525 23.677 32.0888 23.677 30.9C23.677 29.7113 22.7133 28.7476 21.5245 28.7476C20.3358 28.7476 19.3721 29.7113 19.3721 30.9C19.3721 32.0888 20.3358 33.0525 21.5245 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 26.595C35.6284 26.595 36.592 25.6313 36.592 24.4425C36.592 23.2537 35.6284 22.29 34.4396 22.29C33.2508 22.29 32.2871 23.2537 32.2871 24.4425C32.2871 25.6313 33.2508 26.595 34.4396 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 29.824C29.1708 29.824 30.1345 28.8603 30.1345 27.6715C30.1345 26.4827 29.1708 25.519 27.9821 25.519C26.7933 25.519 25.8296 26.4827 25.8296 27.6715C25.8296 28.8603 26.7933 29.824 27.9821 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 26.595C22.7133 26.595 23.677 25.6313 23.677 24.4425C23.677 23.2537 22.7133 22.29 21.5245 22.29C20.3358 22.29 19.3721 23.2537 19.3721 24.4425C19.3721 25.6313 20.3358 26.595 21.5245 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 23.3665C29.1708 23.3665 30.1345 22.4028 30.1345 21.214C30.1345 20.0252 29.1708 19.0615 27.9821 19.0615C26.7933 19.0615 25.8296 20.0252 25.8296 21.214C25.8296 22.4028 26.7933 23.3665 27.9821 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 34,
    width: 14,
    height: 14
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4392 34.1289H21.5244V47.0437H34.4392V34.1289Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 45.9675C35.6284 45.9675 36.592 45.0038 36.592 43.8151C36.592 42.6263 35.6284 41.6626 34.4396 41.6626C33.2508 41.6626 32.2871 42.6263 32.2871 43.8151C32.2871 45.0038 33.2508 45.9675 34.4396 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 49.1965C29.1708 49.1965 30.1345 48.2328 30.1345 47.0441C30.1345 45.8553 29.1708 44.8916 27.9821 44.8916C26.7933 44.8916 25.8296 45.8553 25.8296 47.0441C25.8296 48.2328 26.7933 49.1965 27.9821 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 45.9675C22.7133 45.9675 23.677 45.0038 23.677 43.8151C23.677 42.6263 22.7133 41.6626 21.5245 41.6626C20.3358 41.6626 19.3721 42.6263 19.3721 43.8151C19.3721 45.0038 20.3358 45.9675 21.5245 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 39.51C35.6284 39.51 36.592 38.5463 36.592 37.3575C36.592 36.1688 35.6284 35.2051 34.4396 35.2051C33.2508 35.2051 32.2871 36.1688 32.2871 37.3575C32.2871 38.5463 33.2508 39.51 34.4396 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 42.739C29.1708 42.739 30.1345 41.7753 30.1345 40.5865C30.1345 39.3978 29.1708 38.4341 27.9821 38.4341C26.7933 38.4341 25.8296 39.3978 25.8296 40.5865C25.8296 41.7753 26.7933 42.739 27.9821 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 39.51C22.7133 39.51 23.677 38.5463 23.677 37.3575C23.677 36.1688 22.7133 35.2051 21.5245 35.2051C20.3358 35.2051 19.3721 36.1688 19.3721 37.3575C19.3721 38.5463 20.3358 39.51 21.5245 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 36.2815C29.1708 36.2815 30.1345 35.3178 30.1345 34.129C30.1345 32.9403 29.1708 31.9766 27.9821 31.9766C26.7933 31.9766 25.8296 32.9403 25.8296 34.129C25.8296 35.3178 26.7933 36.2815 27.9821 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 47,
    width: 14,
    height: 13
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4392 47.0435H21.5244V59.9583H34.4392V47.0435Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 58.8821C35.6284 58.8821 36.592 57.9184 36.592 56.7296C36.592 55.5408 35.6284 54.5771 34.4396 54.5771C33.2508 54.5771 32.2871 55.5408 32.2871 56.7296C32.2871 57.9184 33.2508 58.8821 34.4396 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 62.1111C29.1708 62.1111 30.1345 61.1474 30.1345 59.9586C30.1345 58.7698 29.1708 57.8062 27.9821 57.8062C26.7933 57.8062 25.8296 58.7698 25.8296 59.9586C25.8296 61.1474 26.7933 62.1111 27.9821 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 58.8821C22.7133 58.8821 23.677 57.9184 23.677 56.7296C23.677 55.5408 22.7133 54.5771 21.5245 54.5771C20.3358 54.5771 19.3721 55.5408 19.3721 56.7296C19.3721 57.9184 20.3358 58.8821 21.5245 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 52.4246C35.6284 52.4246 36.592 51.4609 36.592 50.2721C36.592 49.0833 35.6284 48.1196 34.4396 48.1196C33.2508 48.1196 32.2871 49.0833 32.2871 50.2721C32.2871 51.4609 33.2508 52.4246 34.4396 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 55.6536C29.1708 55.6536 30.1345 54.6899 30.1345 53.5011C30.1345 52.3123 29.1708 51.3486 27.9821 51.3486C26.7933 51.3486 25.8296 52.3123 25.8296 53.5011C25.8296 54.6899 26.7933 55.6536 27.9821 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5245 52.4246C22.7133 52.4246 23.677 51.4609 23.677 50.2721C23.677 49.0833 22.7133 48.1196 21.5245 48.1196C20.3358 48.1196 19.3721 49.0833 19.3721 50.2721C19.3721 51.4609 20.3358 52.4246 21.5245 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 49.196C29.1708 49.196 30.1345 48.2324 30.1345 47.0436C30.1345 45.8548 29.1708 44.8911 27.9821 44.8911C26.7933 44.8911 25.8296 45.8548 25.8296 47.0436C25.8296 48.2324 26.7933 49.196 27.9821 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: -5,
    width: 14,
    height: 14
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5247 -4.61572H8.60986V8.29908H21.5247V-4.61572Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.525 7.2229C22.7138 7.2229 23.6775 6.25921 23.6775 5.07044C23.6775 3.88166 22.7138 2.91797 21.525 2.91797C20.3363 2.91797 19.3726 3.88166 19.3726 5.07044C19.3726 6.25921 20.3363 7.2229 21.525 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 10.4519C16.2563 10.4519 17.22 9.48821 17.22 8.29944C17.22 7.11066 16.2563 6.14697 15.0675 6.14697C13.8787 6.14697 12.915 7.11066 12.915 8.29944C12.915 9.48821 13.8787 10.4519 15.0675 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 7.2229C9.79876 7.2229 10.7625 6.25921 10.7625 5.07044C10.7625 3.88166 9.79876 2.91797 8.60999 2.91797C7.42121 2.91797 6.45752 3.88166 6.45752 5.07044C6.45752 6.25921 7.42121 7.2229 8.60999 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 0.765382C22.7138 0.765382 23.6775 -0.19831 23.6775 -1.38708C23.6775 -2.57586 22.7138 -3.53955 21.525 -3.53955C20.3363 -3.53955 19.3726 -2.57586 19.3726 -1.38708C19.3726 -0.19831 20.3363 0.765382 21.525 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 3.99439C16.2563 3.99439 17.22 3.03069 17.22 1.84192C17.22 0.653145 16.2563 -0.310547 15.0675 -0.310547C13.8787 -0.310547 12.915 0.653145 12.915 1.84192C12.915 3.03069 13.8787 3.99439 15.0675 3.99439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 0.765382C9.79876 0.765382 10.7625 -0.19831 10.7625 -1.38708C10.7625 -2.57586 9.79876 -3.53955 8.60999 -3.53955C7.42121 -3.53955 6.45752 -2.57586 6.45752 -1.38708C6.45752 -0.19831 7.42121 0.765382 8.60999 0.765382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 14,
    height: 14
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5247 8.29932H8.60986V21.2141H21.5247V8.29932Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.525 20.1379C22.7138 20.1379 23.6775 19.1742 23.6775 17.9855C23.6775 16.7967 22.7138 15.833 21.525 15.833C20.3363 15.833 19.3726 16.7967 19.3726 17.9855C19.3726 19.1742 20.3363 20.1379 21.525 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 23.3669C16.2563 23.3669 17.22 22.4033 17.22 21.2145C17.22 20.0257 16.2563 19.062 15.0675 19.062C13.8787 19.062 12.915 20.0257 12.915 21.2145C12.915 22.4033 13.8787 23.3669 15.0675 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 20.1379C9.79876 20.1379 10.7625 19.1742 10.7625 17.9855C10.7625 16.7967 9.79876 15.833 8.60999 15.833C7.42121 15.833 6.45752 16.7967 6.45752 17.9855C6.45752 19.1742 7.42121 20.1379 8.60999 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 13.6804C22.7138 13.6804 23.6775 12.7167 23.6775 11.528C23.6775 10.3392 22.7138 9.37549 21.525 9.37549C20.3363 9.37549 19.3726 10.3392 19.3726 11.528C19.3726 12.7167 20.3363 13.6804 21.525 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 16.9094C16.2563 16.9094 17.22 15.9457 17.22 14.757C17.22 13.5682 16.2563 12.6045 15.0675 12.6045C13.8787 12.6045 12.915 13.5682 12.915 14.757C12.915 15.9457 13.8787 16.9094 15.0675 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 13.6804C9.79876 13.6804 10.7625 12.7167 10.7625 11.528C10.7625 10.3392 9.79876 9.37549 8.60999 9.37549C7.42121 9.37549 6.45752 10.3392 6.45752 11.528C6.45752 12.7167 7.42121 13.6804 8.60999 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 10.4519C16.2563 10.4519 17.22 9.48821 17.22 8.29944C17.22 7.11066 16.2563 6.14697 15.0675 6.14697C13.8787 6.14697 12.915 7.11066 12.915 8.29944C12.915 9.48821 13.8787 10.4519 15.0675 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 21,
    width: 14,
    height: 14
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5247 21.2139H8.60986V34.1287H21.5247V21.2139Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.525 33.0525C22.7138 33.0525 23.6775 32.0888 23.6775 30.9C23.6775 29.7113 22.7138 28.7476 21.525 28.7476C20.3363 28.7476 19.3726 29.7113 19.3726 30.9C19.3726 32.0888 20.3363 33.0525 21.525 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 36.2815C16.2563 36.2815 17.22 35.3178 17.22 34.129C17.22 32.9403 16.2563 31.9766 15.0675 31.9766C13.8787 31.9766 12.915 32.9403 12.915 34.129C12.915 35.3178 13.8787 36.2815 15.0675 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 33.0525C9.79876 33.0525 10.7625 32.0888 10.7625 30.9C10.7625 29.7113 9.79876 28.7476 8.60999 28.7476C7.42121 28.7476 6.45752 29.7113 6.45752 30.9C6.45752 32.0888 7.42121 33.0525 8.60999 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 26.595C22.7138 26.595 23.6775 25.6313 23.6775 24.4425C23.6775 23.2537 22.7138 22.29 21.525 22.29C20.3363 22.29 19.3726 23.2537 19.3726 24.4425C19.3726 25.6313 20.3363 26.595 21.525 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 29.824C16.2563 29.824 17.22 28.8603 17.22 27.6715C17.22 26.4827 16.2563 25.519 15.0675 25.519C13.8787 25.519 12.915 26.4827 12.915 27.6715C12.915 28.8603 13.8787 29.824 15.0675 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 26.595C9.79876 26.595 10.7625 25.6313 10.7625 24.4425C10.7625 23.2537 9.79876 22.29 8.60999 22.29C7.42121 22.29 6.45752 23.2537 6.45752 24.4425C6.45752 25.6313 7.42121 26.595 8.60999 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 23.3665C16.2563 23.3665 17.22 22.4028 17.22 21.214C17.22 20.0252 16.2563 19.0615 15.0675 19.0615C13.8787 19.0615 12.915 20.0252 12.915 21.214C12.915 22.4028 13.8787 23.3665 15.0675 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 34,
    width: 14,
    height: 14
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5247 34.1289H8.60986V47.0437H21.5247V34.1289Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.525 45.9675C22.7138 45.9675 23.6775 45.0038 23.6775 43.8151C23.6775 42.6263 22.7138 41.6626 21.525 41.6626C20.3363 41.6626 19.3726 42.6263 19.3726 43.8151C19.3726 45.0038 20.3363 45.9675 21.525 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 49.1965C16.2563 49.1965 17.22 48.2328 17.22 47.0441C17.22 45.8553 16.2563 44.8916 15.0675 44.8916C13.8787 44.8916 12.915 45.8553 12.915 47.0441C12.915 48.2328 13.8787 49.1965 15.0675 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 45.9675C9.79876 45.9675 10.7625 45.0038 10.7625 43.8151C10.7625 42.6263 9.79876 41.6626 8.60999 41.6626C7.42121 41.6626 6.45752 42.6263 6.45752 43.8151C6.45752 45.0038 7.42121 45.9675 8.60999 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 39.51C22.7138 39.51 23.6775 38.5463 23.6775 37.3575C23.6775 36.1688 22.7138 35.2051 21.525 35.2051C20.3363 35.2051 19.3726 36.1688 19.3726 37.3575C19.3726 38.5463 20.3363 39.51 21.525 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 42.739C16.2563 42.739 17.22 41.7753 17.22 40.5865C17.22 39.3978 16.2563 38.4341 15.0675 38.4341C13.8787 38.4341 12.915 39.3978 12.915 40.5865C12.915 41.7753 13.8787 42.739 15.0675 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 39.51C9.79876 39.51 10.7625 38.5463 10.7625 37.3575C10.7625 36.1688 9.79876 35.2051 8.60999 35.2051C7.42121 35.2051 6.45752 36.1688 6.45752 37.3575C6.45752 38.5463 7.42121 39.51 8.60999 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 36.2815C16.2563 36.2815 17.22 35.3178 17.22 34.129C17.22 32.9403 16.2563 31.9766 15.0675 31.9766C13.8787 31.9766 12.915 32.9403 12.915 34.129C12.915 35.3178 13.8787 36.2815 15.0675 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 47,
    width: 14,
    height: 13
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5247 47.0435H8.60986V59.9583H21.5247V47.0435Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.525 58.8821C22.7138 58.8821 23.6775 57.9184 23.6775 56.7296C23.6775 55.5408 22.7138 54.5771 21.525 54.5771C20.3363 54.5771 19.3726 55.5408 19.3726 56.7296C19.3726 57.9184 20.3363 58.8821 21.525 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 62.1111C16.2563 62.1111 17.22 61.1474 17.22 59.9586C17.22 58.7698 16.2563 57.8062 15.0675 57.8062C13.8787 57.8062 12.915 58.7698 12.915 59.9586C12.915 61.1474 13.8787 62.1111 15.0675 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 58.8821C9.79876 58.8821 10.7625 57.9184 10.7625 56.7296C10.7625 55.5408 9.79876 54.5771 8.60999 54.5771C7.42121 54.5771 6.45752 55.5408 6.45752 56.7296C6.45752 57.9184 7.42121 58.8821 8.60999 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 52.4246C22.7138 52.4246 23.6775 51.4609 23.6775 50.2721C23.6775 49.0833 22.7138 48.1196 21.525 48.1196C20.3363 48.1196 19.3726 49.0833 19.3726 50.2721C19.3726 51.4609 20.3363 52.4246 21.525 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 55.6536C16.2563 55.6536 17.22 54.6899 17.22 53.5011C17.22 52.3123 16.2563 51.3486 15.0675 51.3486C13.8787 51.3486 12.915 52.3123 12.915 53.5011C12.915 54.6899 13.8787 55.6536 15.0675 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 52.4246C9.79876 52.4246 10.7625 51.4609 10.7625 50.2721C10.7625 49.0833 9.79876 48.1196 8.60999 48.1196C7.42121 48.1196 6.45752 49.0833 6.45752 50.2721C6.45752 51.4609 7.42121 52.4246 8.60999 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 49.196C16.2563 49.196 17.22 48.2324 17.22 47.0436C17.22 45.8548 16.2563 44.8911 15.0675 44.8911C13.8787 44.8911 12.915 45.8548 12.915 47.0436C12.915 48.2324 13.8787 49.196 15.0675 49.196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -5,
    width: 14,
    height: 14
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60962 -4.61572H-4.30518V8.29908H8.60962V-4.61572Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 7.2229C9.79876 7.2229 10.7625 6.25921 10.7625 5.07044C10.7625 3.88166 9.79876 2.91797 8.60999 2.91797C7.42121 2.91797 6.45752 3.88166 6.45752 5.07044C6.45752 6.25921 7.42121 7.2229 8.60999 7.2229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 10.4519C3.34124 10.4519 4.30493 9.48821 4.30493 8.29944C4.30493 7.11066 3.34124 6.14697 2.15247 6.14697C0.963692 6.14697 0 7.11066 0 8.29944C0 9.48821 0.963692 10.4519 2.15247 10.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 0.765382C9.79876 0.765382 10.7625 -0.19831 10.7625 -1.38708C10.7625 -2.57586 9.79876 -3.53955 8.60999 -3.53955C7.42121 -3.53955 6.45752 -2.57586 6.45752 -1.38708C6.45752 -0.19831 7.42121 0.765382 8.60999 0.765382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 3.99439C3.34124 3.99439 4.30493 3.03069 4.30493 1.84192C4.30493 0.653145 3.34124 -0.310547 2.15247 -0.310547C0.963692 -0.310547 0 0.653145 0 1.84192C0 3.03069 0.963692 3.99439 2.15247 3.99439Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 8,
    width: 14,
    height: 14
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60962 8.29932H-4.30518V21.2141H8.60962V8.29932Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 20.1379C9.79876 20.1379 10.7625 19.1742 10.7625 17.9855C10.7625 16.7967 9.79876 15.833 8.60999 15.833C7.42121 15.833 6.45752 16.7967 6.45752 17.9855C6.45752 19.1742 7.42121 20.1379 8.60999 20.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 23.3669C3.34124 23.3669 4.30493 22.4033 4.30493 21.2145C4.30493 20.0257 3.34124 19.062 2.15247 19.062C0.963692 19.062 0 20.0257 0 21.2145C0 22.4033 0.963692 23.3669 2.15247 23.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 13.6804C9.79876 13.6804 10.7625 12.7167 10.7625 11.528C10.7625 10.3392 9.79876 9.37549 8.60999 9.37549C7.42121 9.37549 6.45752 10.3392 6.45752 11.528C6.45752 12.7167 7.42121 13.6804 8.60999 13.6804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 16.9094C3.34124 16.9094 4.30493 15.9457 4.30493 14.757C4.30493 13.5682 3.34124 12.6045 2.15247 12.6045C0.963692 12.6045 0 13.5682 0 14.757C0 15.9457 0.963692 16.9094 2.15247 16.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 10.4519C3.34124 10.4519 4.30493 9.48821 4.30493 8.29944C4.30493 7.11066 3.34124 6.14697 2.15247 6.14697C0.963692 6.14697 0 7.11066 0 8.29944C0 9.48821 0.963692 10.4519 2.15247 10.4519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 21,
    width: 14,
    height: 14
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60962 21.2139H-4.30518V34.1287H8.60962V21.2139Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 33.0525C9.79876 33.0525 10.7625 32.0888 10.7625 30.9C10.7625 29.7113 9.79876 28.7476 8.60999 28.7476C7.42121 28.7476 6.45752 29.7113 6.45752 30.9C6.45752 32.0888 7.42121 33.0525 8.60999 33.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 36.2815C3.34124 36.2815 4.30493 35.3178 4.30493 34.129C4.30493 32.9403 3.34124 31.9766 2.15247 31.9766C0.963692 31.9766 0 32.9403 0 34.129C0 35.3178 0.963692 36.2815 2.15247 36.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 26.595C9.79876 26.595 10.7625 25.6313 10.7625 24.4425C10.7625 23.2537 9.79876 22.29 8.60999 22.29C7.42121 22.29 6.45752 23.2537 6.45752 24.4425C6.45752 25.6313 7.42121 26.595 8.60999 26.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 29.824C3.34124 29.824 4.30493 28.8603 4.30493 27.6715C4.30493 26.4827 3.34124 25.519 2.15247 25.519C0.963692 25.519 0 26.4827 0 27.6715C0 28.8603 0.963692 29.824 2.15247 29.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 23.3665C3.34124 23.3665 4.30493 22.4028 4.30493 21.214C4.30493 20.0252 3.34124 19.0615 2.15247 19.0615C0.963692 19.0615 0 20.0252 0 21.214C0 22.4028 0.963692 23.3665 2.15247 23.3665Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 34,
    width: 14,
    height: 14
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60962 34.1289H-4.30518V47.0437H8.60962V34.1289Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 45.9675C9.79876 45.9675 10.7625 45.0038 10.7625 43.8151C10.7625 42.6263 9.79876 41.6626 8.60999 41.6626C7.42121 41.6626 6.45752 42.6263 6.45752 43.8151C6.45752 45.0038 7.42121 45.9675 8.60999 45.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 49.1965C3.34124 49.1965 4.30493 48.2328 4.30493 47.0441C4.30493 45.8553 3.34124 44.8916 2.15247 44.8916C0.963692 44.8916 0 45.8553 0 47.0441C0 48.2328 0.963692 49.1965 2.15247 49.1965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 39.51C9.79876 39.51 10.7625 38.5463 10.7625 37.3575C10.7625 36.1688 9.79876 35.2051 8.60999 35.2051C7.42121 35.2051 6.45752 36.1688 6.45752 37.3575C6.45752 38.5463 7.42121 39.51 8.60999 39.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 42.739C3.34124 42.739 4.30493 41.7753 4.30493 40.5865C4.30493 39.3978 3.34124 38.4341 2.15247 38.4341C0.963692 38.4341 0 39.3978 0 40.5865C0 41.7753 0.963692 42.739 2.15247 42.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 36.2815C3.34124 36.2815 4.30493 35.3178 4.30493 34.129C4.30493 32.9403 3.34124 31.9766 2.15247 31.9766C0.963692 31.9766 0 32.9403 0 34.129C0 35.3178 0.963692 36.2815 2.15247 36.2815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_100_6374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 47,
    width: 14,
    height: 13
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60962 47.0435H-4.30518V59.9583H8.60962V47.0435Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_100_6374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 58.8821C9.79876 58.8821 10.7625 57.9184 10.7625 56.7296C10.7625 55.5408 9.79876 54.5771 8.60999 54.5771C7.42121 54.5771 6.45752 55.5408 6.45752 56.7296C6.45752 57.9184 7.42121 58.8821 8.60999 58.8821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 62.1111C3.34124 62.1111 4.30493 61.1474 4.30493 59.9586C4.30493 58.7698 3.34124 57.8062 2.15247 57.8062C0.963692 57.8062 0 58.7698 0 59.9586C0 61.1474 0.963692 62.1111 2.15247 62.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 52.4246C9.79876 52.4246 10.7625 51.4609 10.7625 50.2721C10.7625 49.0833 9.79876 48.1196 8.60999 48.1196C7.42121 48.1196 6.45752 49.0833 6.45752 50.2721C6.45752 51.4609 7.42121 52.4246 8.60999 52.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 55.6536C3.34124 55.6536 4.30493 54.6899 4.30493 53.5011C4.30493 52.3123 3.34124 51.3486 2.15247 51.3486C0.963692 51.3486 0 52.3123 0 53.5011C0 54.6899 0.963692 55.6536 2.15247 55.6536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15247 49.196C3.34124 49.196 4.30493 48.2324 4.30493 47.0436C4.30493 45.8548 3.34124 44.8911 2.15247 44.8911C0.963692 44.8911 0 45.8548 0 47.0436C0 48.2324 0.963692 49.196 2.15247 49.196Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory3);
export default __webpack_public_path__ + "static/media/accessory-3.0bb5fd0a04eedb06cfaebddba02a8ef7.svg";
export { ForwardRef as ReactComponent };